class Header {
  constructor(parent) {
    this.parent = parent;
    if (!this.parent) {
      return;
    }
    this.init();
  }

  setAccordions=()=>{
    const parent = this.parent;
    const accordions = parent.querySelectorAll('.accordion-toggle');
    const subAccordions = parent.querySelectorAll('.sub-accordion-toggle');
    let rdlink = parent.querySelectorAll('.label');
    rdlink.forEach((link)=>{
      link.addEventListener("click",(e)=>{
        let rdcondition = link.getAttribute("data-redirect");
        if(rdcondition != 'true'){
          e.preventDefault();
        }
      })})
    accordions.forEach(toggle => {
      toggle.addEventListener('click', (e) => {
        accordions.forEach(element => {
          element !== toggle && element.classList.remove("active");
        });
        // toggle.classList.toggle('active');
        let textclick = e.target.closest('a');
        
        if(toggle.classList.contains("active")){
          if(textclick){
            let reurl = textclick.href;
            window.location.href = reurl;  
          }
          else{
            toggle.classList.remove('active');
          }
        }
        else{
          toggle.classList.add('active');
        }
      });
    });
  
    subAccordions.forEach(toggle => {
      toggle.addEventListener('click', (e) => {
        // Check if click is specifically on the arrow or its image
        const isArrowClick = e.target.closest('.arrow') || e.target.classList.contains('arrow') || e.target.tagName === 'IMG';
        
        // If clicking on arrow, prevent the default link behavior and stop propagation
        if (isArrowClick) {
          e.preventDefault();
          e.stopPropagation();
        }

        subAccordions.forEach(element => {
          element !== toggle && element.classList.remove("active");
        });

        let textclick = e.target.closest('a');
        
        if(toggle.classList.contains("active")){
          if(textclick && !isArrowClick){
            let reurl = textclick.href;
            window.location.href = reurl;  
          }
          else{
            toggle.classList.remove('active');
          }
        }
        else{
          toggle.classList.add('active');
        }
      });
    });    
  }
  clickEvents=()=>{
    const header = document.querySelector('.custom-header');
    const toggle = document.getElementById('mobile-toggle');
    const drawer = document.getElementById('mobile-drawer');
    const mobileOverlay = document.querySelector(".mobile-overlay");
    const openBtn = document.getElementById('mobile-menu-open');
    const closeBtn = document.querySelector('.mobile-menu-close');
    const labelDrawer = document.querySelector(".label-side-drawer");
    const labelTodayDeals = document.querySelector(".today-deals");
    const labelDrawerClose = document.querySelector(".close-label-drawer");

    const toggleLinks = document.querySelectorAll(".read-toggle");
    toggleLinks.forEach((toggleLink)=>{
      toggleLink.addEventListener("click",()=>{
        const wrapper = toggleLink.closest('.deal-description-wrapper');
        const shortText = wrapper.querySelector('.short');
        const fullText = wrapper.querySelector('.full');

        const isExpanded = fullText.classList.contains('expanded');

        if (isExpanded) {
          fullText.classList.remove('expanded');
        } else {
          fullText.classList.add('expanded');
        }
      })
    })

    if(labelDrawer && labelTodayDeals){
      labelTodayDeals.addEventListener("click",()=>{
        labelDrawer.classList.add("open")
        document.body.classList.add("overflow-hidden");
      });
    }
    if(labelDrawer && labelDrawerClose){
      labelDrawerClose.addEventListener("click",()=>{
        labelDrawer.classList.remove("open");
        document.body.classList.remove("overflow-hidden");
      });
    }

    if(toggle && drawer){
      toggle.addEventListener('click', ()=> {
        drawer.classList.toggle('open');
        if(drawer.classList.contains("open")){
          document.body.classList.add("overflow-hidden");
        }else{
          document.body.classList.remove("overflow-hidden");
        }
      });
    }

    // setTimeout(()=>{
    //   // document.body.style.marginTop = `${this.parent.clientHeight}px`;
    //   if(window.scrollY && window.innerWidth > 1024){
    //     // header.classList.add('sticky');
    //   }
    //   window.addEventListener('scroll', ()=> {
    //     if(window.innerWidth > 1024){
    //       if (window.scrollY > 50) {
    //         header.classList.add('sticky');
    //         // document.body.style.marginTop = `${this.parent.clientHeight}px`;
    //       } else {
    //         header.classList.remove('sticky');
    //         // document.body.style.marginTop = `${this.parent.clientHeight}px`;
    //       }
    //     }
    //   });
    // },400)

    if (openBtn && drawer) {
      openBtn.addEventListener('click', () => drawer.classList.add('open'));
    }
  
    if (closeBtn && drawer) {
      closeBtn.addEventListener('click', () => drawer.classList.remove('open'));
    }
    mobileOverlay && mobileOverlay.addEventListener("click",() => {
      closeBtn && closeBtn.click();
      labelDrawerClose && labelDrawerClose.click();
      document.body.classList.remove("overflow-hidden");
    })
    if(closeBtn) {
      closeBtn.addEventListener("click",() => {
        document.body.classList.remove("overflow-hidden");
      })
    }
  }
  setCartEvents=()=>{
    const parent = this.parent;
    const cartIcon = parent?.querySelector(".header-cart-btn");
    const cartPopup = document.querySelector(".ctdrawer");
    cartIcon && cartIcon.addEventListener("click",(e)=>{
      if(window.innerWidth < 850){
        e.preventDefault();
        // cartPopup && cartPopup.classList.toggle("active");
      }
    })
  }
  init=()=>{
    this.clickEvents();
    this.setAccordions();
    this.setCartEvents();
  }  
}

const header = document.querySelector(".custom-header");
if(header){
  new Header(header);
}